export default {"src":"/_next/static/media/FAST.f02f4a30.svg","height":18,"width":18};